module.exports = __webpack_public_path__ + "img/kava.996967f7.jpg";